export default "__VITE_ASSET__31c002e6__"